import { Reveal } from "@/lib/motion";
import { BIO } from "@/data/site";

// "Meet Michael" — About page. With a portrait: two columns (4:5 portrait beside the bio).
// Without one: a clean text layout. Never a stock person, generated portrait, or "coming soon" placeholder.
export const MeetMichael = () => (
  <section data-testid="meet-michael" className="bg-cream-ivory py-28 border-t border-[#D9CFB8]">
    <div className={`max-w-[1300px] mx-auto px-6 lg:px-10 ${BIO.portrait ? "grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" : ""}`}>
      {BIO.portrait && (
        <Reveal className="lg:col-span-5">
          <figure data-testid="portrait-frame" className="group overflow-hidden rounded-[6px] border border-[#D8D1C5] bg-cream max-w-[360px] mx-auto lg:mx-0"
            style={{ boxShadow: "0 6px 20px rgba(15, 23, 42, 0.06)" }}>
            <img src={BIO.portrait} alt="Michael, founder of Oakford Ledger" width={360} height={450} loading="lazy" decoding="async"
              className="block w-full h-auto aspect-[4/5] object-cover motion-safe:group-hover:scale-[1.03] transition-transform duration-700 ease-out" />
          </figure>
        </Reveal>
      )}
      <div className={BIO.portrait ? "lg:col-span-7" : "max-w-3xl"}>
        <Reveal>
          <p className="font-mono text-[12px] uppercase tracking-[0.28em] text-[#8a6b2f] mb-5">{BIO.role}</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-navy tracking-tight leading-tight">{BIO.heading}</h2>
        </Reveal>
        <div data-testid="meet-michael-bio" className="mt-8 space-y-6 text-ink text-lg leading-relaxed">
          {BIO.paragraphs.map((p, i) => <Reveal key={i} delay={i * 0.05}><p>{p}</p></Reveal>)}
        </div>
      </div>
    </div>
  </section>
);
